import { render } from "./UiRating.pug?vue&type=template&id=53a27f54&lang=pug"
import script from "./UiRating.js?vue&type=script&lang=js"
export * from "./UiRating.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__